import Api, { handleData, handleError } from '../Api';
import { TravelFileServiceTypes } from '../services/constants/travelFileService';

import { url } from './config';
import { ServicePrice } from './types';

class ExtendedApi extends Api<ServicePrice> {
    getIsExistInMoreThenOneSameService(id: string, serviceModelType: TravelFileServiceTypes) {
        return this.request
            .get(`${url}-inMultipleSameService/${id}`, { params: { serviceModelType } })
            .then(handleData)
            .catch(handleError);
    }

    batchUpdate(items: Partial<ServicePrice>[]) {
        return this.request.put(`${url}-batch`, { items }).then(handleData).catch(handleError);
    }
}

const api = new ExtendedApi(url);

export default api;
